import { action, observable } from 'mobx';
import Container, { Service } from 'typedi';
import { HttpService, ResponseDTO } from '@/shared';
import { EncryptionDTO } from '@/shared/dto/encryption.dto';

@Service()
export class EncryptionService {
  @observable
  private httpService = Container.get(HttpService);

  @action.bound
  public async getPublicKey(encryptionDTO: EncryptionDTO): Promise<ResponseDTO<string>> {
    return this.httpService.request(encryptionDTO);
  }

}
